<template>
  <div class="content-item">
    <div class="mt-4">
      <h2 class="heading">Please Upload Your Church Logo and Any Other Files You Need to Create Your Card</h2>
      <p class="text">If you want to upload an additional file, you can do it here</p>
      <div v-if="previewImage" class="pb-4">
        <div class="mb-4">
          <a-button size="large" class="text-center btn btn-warning font-size-18 mr-4" @click="onDelete"><a-icon type="delete" /></a-button>
          <!-- <a-button size="large" class="text-center btn btn-primary font-size-18" @click="onUploadImage">
            <template v-if="!isLoading"> <a-icon type="upload" /> Please Update file </template>
            <template v-else> <a-icon type="loading" /> Uploading {{ percent }}% </template>
          </a-button> -->
        </div>
        <img v-if="isImage" :src="previewImage" style="width: 200px" />
        <template v-else>
          <a-icon type="file-add" class="ml-1" />
          <span>{{ previewImage.name }}</span>
        </template>
      </div>
      <div class="form-upload-other" v-else>
        <a-upload action list-type="picture-card" :file-list="fileSelected" :before-upload="beforeUpload" @change="handleChange">
          <div v-if="fileSelected.length === 0">
            <div>
              <a-icon type="cloud-upload" />
              <div>
                <b>Drag and drop files here</b>
                <p>Max. file size: 10.6MB</p>
              </div>
            </div>
            <div class="ant-upload-text">Browse Files</div>
          </div>
        </a-upload>
      </div>
    </div>
    <!-- <div class="mt-4">
      <div v-if="previewImageLogo" class="pb-4">
        <div class="mb-4">
          <a-button size="large" class="text-center btn btn-warning font-size-18 mr-4" @click="onDeleteLogo"><a-icon type="delete" /></a-button>
        </div>
        <img :src="previewImageLogo" style="width: 200px" />
      </div>
      <div class="form-upload" v-else>
        <a-upload
          accept="image/png, image/gif, image/jpeg, image/jpg, image/svg"
          action
          list-type="picture-card"
          :file-list="fileSelectedLogo"
          :before-upload="beforeUpload"
          @change="handleChangeLogo"
        >
          <div v-if="fileSelectedLogo.length === 0">
            <div class="ant-upload-text">SELECT IMAGE</div>
          </div>
        </a-upload>
      </div>
    </div> -->
  </div>
</template>

<script>
import { empty, getBase64 } from '@/utils';
import Uploader from '@/services/UploadService';

export default {
  name: 'Step4',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      fileSelected: [],
      previewImage: null,
      percent: 0,
      isLoading: false,
      isImage: false,
      fileSelectedLogo: [],
      previewImageLogo: null,
      isUploaded: false,
      isLoadingLogo: false,
    };
  },
  watch: {
    percent(value) {
      this.$emit('onNextTextChanged', `Uploading ${value}%`);
    },
  },
  methods: {
    beforeUpload(file) {
      return false;
    },
    onDelete() {
      this.$emit('onNextTextChanged', '');
      this.previewImage = null;
      this.fileSelected = [];
      this.isLoading = false;
      this.percent = 0;
    },
    onDeleteLogo() {
      this.$emit('onNextTextChanged', '');
      this.previewImageLogo = null;
      this.fileSelectedLogo = [];
      this.isLoadingLogo = false;
      this.percentLogo = 0;
    },
    handleChangeLogo({ fileList }) {
      if (!empty(fileList)) {
        const image = new Image();
        image.src = URL.createObjectURL(fileList[0].originFileObj);
        image.onload = () => {
          this.fileSelectedLogo = fileList;
          this.previewImageLogo = URL.createObjectURL(fileList[0].originFileObj);
          this.$emit('onNextTextChanged', 'Upload');
        };
      }
    },
    handleChange({ fileList }) {
      this.isImage = false;
      if (!empty(fileList)) {
        this.isImage = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(fileList[0].name);
        if (this.isImage) {
          const image = new Image();
          image.src = URL.createObjectURL(fileList[0].originFileObj);
          image.onload = () => {
            this.fileSelected = fileList;
            this.previewImage = URL.createObjectURL(fileList[0].originFileObj);
            this.$emit('onNextTextChanged', 'Upload');
          };
        } else {
          this.fileSelected = fileList;
          this.previewImage = fileList[0];
          this.$emit('onNextTextChanged', 'Upload');
        }
      }
    },
    async submit() {
      if (!this.isLoading && !empty(this.fileSelected)) {
        try {
          this.isLoading = true;
          this.percent = 0;
          const fileContent = this.fileSelected[0];
          let file = {
            contentType: fileContent.type, // you can set it based on the type of image you are uploading like image/png
            fileName: fileContent.name,
            file: await getBase64(fileContent.originFileObj),
          };
          this.$emit('onNextTextChanged', `Uploading...`);
          const resp = await new Uploader().uploadImage(file, percent => (this.percent = percent));
          this.$emit('input', {
            ...this.value,
            other_file: resp.Location,
          });
        } catch (error) {
          console.log({ error });
        } finally {
          this.isLoading = false;
          this.percent = 0;
        }
      }
      if (!this.isLoadingLogo && !empty(this.fileSelectedLogo) && !this.isUploaded) {
        try {
          this.isLoadingLogo = true;
          this.percent = 0;
          const fileContent = this.fileSelectedLogo[0];
          let file = {
            contentType: fileContent.type, // you can set it based on the type of image you are uploading like image/png
            fileName: fileContent.name,
            file: await getBase64(fileContent.originFileObj),
          };
          this.$emit('onNextTextChanged', `Uploading...`);
          const resp = await new Uploader().uploadImage(file, percent => (this.percent = percent));
          this.isUploaded = true;
          this.$emit('input', {
            ...this.value,
            church_logo: resp.Location,
          });
        } catch (error) {
          console.log({ error });
        } finally {
          this.isLoadingLogo = false;
          this.percent = 0;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.form-upload-other {
  border: 2px dashed #4987c5;
  border-radius: 10px;
  background-color: #f4f7fa;
  text-align: center;
  padding: 10px;
  .ant-upload-picture-card-wrapper {
    display: block;
  }
  .ant-upload {
    border: none;
    background: none;
    margin: 0;
    margin: auto;
    float: none;

    &.ant-upload-select-picture-card {
      width: 100%;
      height: initial;
    }
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div:not(.ant-upload-text) {
        display: flex;
        align-items: center;
        text-align: left;
        > i {
          color: #94bfea;
          font-size: 40px;
          margin-right: 10px;
        }
      }
      .ant-upload-text {
        background: #026cd6;
        border-radius: 4px;
        padding: 10px 20px;
        color: #fff;
        text-transform: uppercase;
      }
    }
  }
}
</style>
